export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "bb-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "bb-themeWrapLive" */'./LiveThemeImporter'),
  },
};
